<template>
  <div class="chat-container">
     <div class="alert-box">
      <div v-if="!isEditing" class="editable" @click="editThreshold">
      <span>청산금액 </span>
      <span style="text-decoration: underline;">
        <u>{{ threshold }}달러</u>
      </span>
      <span> 이상 경우 알림</span>
      </div>
      <div v-else>
      <input
        type="number"
        v-model="inputValue"
        @blur="saveThreshold"
        @keyup.enter="saveThreshold"
        class="input-field"
      />
      <button class="nickname-save-btn" @click="saveThreshold">수정</button>
      </div>
      
    </div>
    <!-- 닉네임 표시 (클릭 가능) -->
    <div class="nickname-box">
      <div v-if="!isEditingNickname">
        <span class="nickname-text" @click="editNickname" :style="{color: fontColor}">{{ nickname }}</span>
      </div>
      <div v-else>
        <input v-model="newNickname" class="nickname-input" @keyup.enter="saveNickname">
        <button class="nickname-save-btn" @click="saveNickname">수정</button>
      </div>
    </div>
    <div class="chat-window" ref="chatWindow" @scroll="handleScroll">
      <div v-for="(msg,index) in messages" :key="msg.id" class="chat-message" style="text-align:left">
        <!--
        <div v-if="index === 0 || (messages[index - 1] &&messages[index - 1].nickname !== msg.nickname)">
        -->
        <div v-if="msg.arlim === 'Y'">
          <div>
          <span class="chat-nickname" :style="{fontSize:'0.8rem',color: msg.fontColor}">{{ msg.nickname }}</span>
          <div class="chat-text" :style="{fontSize:'0.85rem',color: msg.contentColor}">{{ msg.content }}</div>
          </div>
        </div>
        <div v-else>
          <div v-if="showNickname(index,msg)">
          <span class="chat-nickname" :style="{fontSize:'0.8rem',color: msg.fontColor}">{{ msg.nickname }}</span>
          <span class="chat-timestamp" style="font-size:0.7rem;">[{{ msg.timestamp.split(' ')[1] ? msg.timestamp.split(' ')[1].substring(0, 5) : ''}}]</span>
          </div>
          <div class="chat-text" style="font-size:0.85rem;">{{ msg.content }}</div>
        </div>
      </div>
    </div>
    <div class="chat-input-area">
      <input type="text" v-model="message" class="chat-input" @keyup.enter="sendMessage" maxlength="200">
      <button class="chat-send-btn" @click="sendMessage">전송</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    coinValues: Object,  // 부모로부터 코인 리스트를 props로 받음
  },
  data() {
    return {
      socket: null, // WebSocket 객체
      binance_future_socket: null, // WebSocket 객체
      nickname: '',
      newNickname: '',
      message: '',
      messages: [],
      fontColor: '',
      threshold: 0,
      isEditing: false,
      inputValue: '',
      isEditingNickname: false,
      isInitialScrollDone: false,
      isUserScrolling: false
    };
  },
  methods: {
    editThreshold() {
      this.inputValue = this.threshold;
      this.isEditing = true;
    },

    saveThreshold() {
      if (this.inputValue === "") {
        this.inputValue.value = 0;
      }
      this.threshold = this.inputValue;
      localStorage.setItem("threshold", this.threshold); // LocalStorage 저장
      this.isEditing = false;
    },
    editNickname() {
      this.newNickname = this.nickname;
      this.isEditingNickname = true;
    },
    saveNickname() {
      if (this.newNickname.trim() === '') return;
      this.nickname = this.newNickname.trim();
      localStorage.setItem('nickname', this.nickname);
      this.isEditingNickname = false;
    },
    showNickname(index,msg){
      if(index ===0 ){
        return true;
      }
    if(this.messages[index - 1] && this.messages[index - 1].nickname === msg.nickname){
      
      let time = msg.timestamp.split(' ')[1] ? msg.timestamp.split(' ')[1].substring(0, 5) : '';
      let time2 = this.messages[index - 1].timestamp.split(' ')[1] ? this.messages[index - 1].timestamp.split(' ')[1].substring(0, 5) : '';
     if(time2 === time){
        return false;
      }
    }

    return true;
    

    },
    getRandomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r}, ${g}, ${b})`;
    },
    // 스크롤 이벤트 핸들러
    handleScroll() {
      const chatWindow = this.$refs.chatWindow;
      // 사용자가 수동으로 스크롤을 올렸는지 체크
      setTimeout(() => {
      this.$nextTick(() => {
      this.isUserScrolling = chatWindow.scrollTop < chatWindow.scrollHeight - chatWindow.clientHeight - 10;
       });
       }, 300);
    },

    // 채팅창 하단으로 스크롤
    scrollToBottom() {
      setTimeout(() => {
        this.$nextTick(() => {
         if (this.$refs.chatWindow) {
          this.$refs.chatWindow.scrollTop = this.$refs.chatWindow.scrollHeight;
          this.isInitialScrollDone = true;
          }
        });
      }, 300);
    },
    // WebSocket 연결
    connectWebSocket() {
      //const wsUrl = "ws://localhost:8787/chat/1";
      const wsUrl = "wss://api2.kimpmoa.com/chat/1";
        
      this.socket = new WebSocket(wsUrl);

      this.socket.onopen = () => {
        //console.log("✅ WebSocket 연결됨!");
      };

      this.socket.onmessage = (event) => {
        const receivedMessage = JSON.parse(event.data);
        this.messages.push(receivedMessage);
         if (!this.isInitialScrollDone) {
            this.$nextTick(() => {
             if (this.$refs.chatWindow) {
              this.$refs.chatWindow.scrollTop = this.$refs.chatWindow.scrollHeight;
              this.isInitialScrollDone = true;
              }
            });
         }
         if (!this.isUserScrolling) {
          this.scrollToBottom(); // 자동 스크롤
        }
      };

      this.socket.onerror = (error) => {
        console.error("❌ WebSocket 오류:", error);
      };

      this.socket.onclose = () => {
        //console.log("❌ WebSocket 연결이 종료되었습니다.");
      };
    },
    // WebSocket 연결
    connectBinanceWebSocket() {
      //const wsUrl = "ws://localhost:8787/chat/1";
      this.binance_future_ws = new WebSocket("wss://fstream.binance.com/ws/!forceOrder@arr");
 
      this.binance_future_ws.onopen = () => {
        //console.log("✅ WebSocket 연결됨!");
      };

      this.binance_future_ws.onmessage = (event) => {
       const receivedMessage = JSON.parse(event.data);

      let totalAMt = Math.floor(receivedMessage.o.ap * receivedMessage.o.z);
      if(totalAMt > this.threshold){
        let text = receivedMessage.o.s;
        let contentRGB = 'rgb(0, 0, 0)';
        if(receivedMessage.o.S === 'BUY'){
          text = text + ' 숏 청산가 $' + receivedMessage.o.ap +'/금액 $'+ totalAMt.toLocaleString();
          contentRGB = 'rgb(255, 0, 0)';
        }else{
          text = text + ' 롱 청산가 $' + receivedMessage.o.ap +'/금액 $'+ totalAMt.toLocaleString();
          contentRGB = 'rgb(0, 0, 255)';
        }


        const newMessage = {
            arlim: "Y",
            nickname: '[바이낸스 청산알림]',
            content: text,
            fontColor: 'rgb(0, 0, 0)',
            contentColor: contentRGB,
          };

          this.messages.push(newMessage);
          if (!this.isInitialScrollDone) {
              this.$nextTick(() => {
              if (this.$refs.chatWindow) {
                this.$refs.chatWindow.scrollTop = this.$refs.chatWindow.scrollHeight;
                this.isInitialScrollDone = true;
                }
              });
          }
          if (!this.isUserScrolling) {
            this.scrollToBottom(); // 자동 스크롤
          }
        }
      };

      this.binance_future_ws.onerror = (error) => {
        console.error("❌ WebSocket 오류:", error);
      };

      this.binance_future_ws.onclose = () => {
        //console.log("❌ WebSocket 연결이 종료되었습니다.");
      };
    },

    // 메시지 전송
    sendMessage() {
      if (this.message.trim() !== "" && this.socket && this.socket.readyState === WebSocket.OPEN) {
      if (this.message.length > 200) {
        alert("메시지는 200자 이하로 입력해야 합니다.");
        return; // 200자 초과 시 전송하지 않음
      } 

      this.message = this.extractCoinInfo(this.message.trim());
      const newMessage = {
          type: "chat",
          nickname: this.nickname,
          content: this.message,
          fontColor: this.fontColor,
        };
        this.socket.send(JSON.stringify(newMessage)); // WebSocket으로 메시지 전송
        this.message = ""; // 입력창 초기화
      }
    },
     extractCoinInfo(text) {
      let oriText = text;
      for (let k in this.coinValues.value) {
        let coinName = this.coinValues.value[k].korean_name;
        let regex = new RegExp(`(\\d+)\\s*${coinName}`, "g");
        let match = regex.exec(text);
        if (match) {
          let amount = match[1] ? parseInt(match[1], 10) : 1; // 숫자가 없으면 1로 처리
          let price = this.coinValues.value[k].trade_price*amount;
          let change = this.formatPercentage(this.coinValues.value[k].signed_change_rate);
          return oriText.replaceAll(coinName,coinName+'('+price.toLocaleString()+'원, '+change+'%)');
        }

        let coinName2 = this.coinValues.value[k].market.replaceAll('KRW-','');
        let regex2 = new RegExp(`(\\d+)\\s*${coinName2}`, "g");
        let match2 = regex2.exec(text);
        if (match2) {
          let amount = match2[1] ? parseInt(match2[1], 10) : 1; // 숫자가 없으면 1로 처리
          let price = this.coinValues.value[k].trade_price*amount;
          let change = this.formatPercentage(this.coinValues.value[k].signed_change_rate);
          return oriText.replaceAll(coinName2,coinName2+'('+price.toLocaleString()+'원, '+change+'%)');
        }

        let coinName3 = coinName2.toLowerCase();
        let regex3 = new RegExp(`(\\d+)\\s*${coinName3}`, "g");
        let match3 = regex3.exec(text);
        if (match3) {
          let amount = match3[1] ? parseInt(match3[1], 10) : 1; // 숫자가 없으면 1로 처리
          let price = this.coinValues.value[k].trade_price*amount;
          let change = this.formatPercentage(this.coinValues.value[k].signed_change_rate);
          return oriText.replaceAll(coinName3,coinName3+'('+price.toLocaleString()+'원, '+change+'%)');
        }

      }
      return oriText;
    },
    formatPercentage(value) {
      return (value * 100).toFixed(2) ; // 100을 곱하고 소수점 1자리까지 표시
    },
  },
  mounted() {
  if((localStorage.getItem('nickname') !== '' && localStorage.getItem('nickname')!=='undefined'&& localStorage.getItem('nickname')!==null )){
    this.nickname = localStorage.getItem('nickname')
  }else{
    this.nickname = `익명_${Math.floor(Math.random() * 100000)}`;
    localStorage.setItem('nickname', this.nickname);
  }
  if((localStorage.getItem('fontColor') !== '' && localStorage.getItem('fontColor')!=='undefined'&& localStorage.getItem('fontColor')!==null)){
    this.fontColor = localStorage.getItem('fontColor')
  }else{
    this.fontColor = this.getRandomColor();
    localStorage.setItem('fontColor', this.fontColor);
  }
  if((localStorage.getItem('threshold') !== '' && localStorage.getItem('threshold')!=='undefined'&& localStorage.getItem('threshold')!==null)){
    this.threshold = localStorage.getItem('threshold')
  }else{
    this.threshold = 10000;
    localStorage.setItem('threshold', this.threshold);
  }

  
    // 컴포넌트가 마운트된 후 WebSocket 연결
    this.connectWebSocket();
    this.connectBinanceWebSocket();
  }
};
</script>

<style scoped>

.chat-container {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.chat-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 15px;
}

.chat-window {
  height: 450px;
  overflow-y: auto;
  border: 1px solid #ddd;
  background: white;
  padding: 10px;
  border-radius: 5px;
}

.chat-message {
  border-radius: 5px;
}

.chat-nickname {
  font-weight: bold;
  color: #007bff;
}

.chat-timestamp {
  font-size: 0.8rem;
  color: gray;
  margin-left: 5px;
}

.chat-text {
  word-break: break-word; /* 긴 단어가 줄바꿈 되도록 설정 */
  white-space: pre-wrap; /* 공백과 줄바꿈을 유지하면서 자동 줄바꿈 */
  overflow-wrap: break-word; /* 단어가 길어도 자동 줄바꿈 */
  max-width: 100%; /* 컨테이너 너비를 초과하지 않도록 제한 */
}

.chat-input-area {
  display: flex;
  flex-wrap: wrap; /* 화면 크기에 맞춰 아이템들이 자동으로 줄어들도록 설정 */

}

.chat-input {
  flex: 1;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
   min-width: 0;
}

.chat-send-btn {
  width:100px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 80px;
}

.chat-send-btn:hover {
  background: #0056b3;
}
.nickname-box {
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 5px;
  font-size: 0.8rem;
}

.nickname-label {
  font-weight: bold;
  margin-right: 5px;
}

.nickname-text {
  cursor: pointer;
  text-decoration: underline;
}

.nickname-input {
  flex: 1;
  max-width:120px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.nickname-save-btn {
  margin-left: 5px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.nickname-save-btn:hover {
  background: #0056b3;
}

.nickname-icon {
  margin-right: 5px;
}
.alert-box {
  padding:4px;
  text-align:left;
  font-size: 0.8rem;
}
.editable {
  cursor: pointer;
}
.input-field {
  width: 120px;
  font-size: 16px;
  text-align: center;
}
</style>
